var swiper = new Swiper('.swiper1', {
  slidesPerView: 1.25,
  spaceBetween: 0,
  centeredSlides: true,
  followFinger: true,
  initialSlide: 0,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      initialSlide: 0
    },
    945: {
      slidesPerView: 4,
      initialSlide: 1
    }      
  }   
});